export default __webpack_public_path__ + "static/media/twitterOutline.367128ef.svg";